/* pc-cart-extras.js: moved out of snippets/pc-cart-extras.liquid inline script (Page Weight, Oct 2026). */
(function () {
  if (window.__pcCartExtrasJs) return;
  window.__pcCartExtrasJs = true;
  (function () {
    if (window.__pcCartExtras) return; window.__pcCartExtras = true;

    function refreshDrawer() {
      var url = location.pathname + '?sections=cart-drawer,cart-icon-bubble';
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (s) {
        var doc = new DOMParser().parseFromString(s['cart-drawer'] || '', 'text/html');
        ['.cart-drawer__items', '.cart-drawer__footer--subtotal'].forEach(function (sel) {
          var src = doc.querySelector(sel), dst = document.querySelector('cart-drawer ' + sel);
          if (src && dst) dst.innerHTML = src.innerHTML;
        });
        if (s['cart-icon-bubble']) {
          var b = document.getElementById('cart-icon-bubble');
          var bd = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b && bd) b.innerHTML = bd.innerHTML;
        }
      });
    }
    function codesOf(box) { return (box.getAttribute('data-codes') || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean); }
    function setMsg(text, ok) {
      var m = document.querySelector('cart-drawer [data-pcc-msg]'); if (!m) return;
      m.textContent = text || ''; m.classList.toggle('is-ok', !!ok);
    }
    function applyCodes(list, focusCode, removing) {
      return fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: list.join(',') })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        if (!removing && focusCode && !Array.isArray(cart.discount_codes)) {
          // Older storefronts: fall back to Shopify's discount link
          location.href = '/discount/' + encodeURIComponent(focusCode) + '?redirect=' + encodeURIComponent(location.pathname + location.search);
          return;
        }
        return refreshDrawer().then(function () {
          if (removing || !focusCode) return;
          var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === focusCode.toUpperCase(); })[0];
          if (hit && hit.applicable) setMsg('Code ' + hit.code + ' Applied!', true);
          else setMsg('That Code Isn’t Valid for the Items in Your Cart.', false);
        });
      });
    }

    /* ---------- recommended products row ---------- */
    var recBusy = false, recKey = '';
    function money(c) { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(c / 100); } catch (e) { return '$' + (c / 100).toFixed(2); } }
    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
    function sized(u, w) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
    function bestVariant(p) {
      var best = null;
      (p.variants || []).forEach(function (v) { if (v.available && (!best || v.price > best.price)) best = v; });
      return best;
    }
    function navUpdate(box) {
      var row = box.querySelector('[data-pcr-row]'), max = row.scrollWidth - row.clientWidth - 2;
      box.querySelector('[data-pcr-prev]').disabled = row.scrollLeft <= 2;
      box.querySelector('[data-pcr-next]').disabled = row.scrollLeft >= max;
      box.querySelector('.pcr-nav').style.visibility = max <= 0 ? 'hidden' : '';
    }
    function loadRecs(force) {
      var box = document.querySelector('cart-drawer [data-pcr]'); if (!box || recBusy) return;
      recBusy = true;
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var inCart = {}; (cart.items || []).forEach(function (i) { inCart[i.product_id] = 1; });
        var seeds = (cart.items || []).map(function (i) { return i.product_id; }).filter(function (v, i, a) { return a.indexOf(v) === i; }).slice(0, 2);
        if (!seeds.length) { box.hidden = true; return; }
        var key = seeds.join(',') + '|' + Object.keys(inCart).join(',');
        if (!force && key === recKey && box.querySelector('.pcr-card')) { box.hidden = false; return; }
        recKey = key;
        var limit = parseInt(box.getAttribute('data-limit'), 10) || 8;
        return Promise.all(seeds.map(function (id) {
          return fetch('/recommendations/products.json?product_id=' + id + '&limit=' + limit + '&intent=related', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; });
        })).then(function (lists) {
          var seen = {}, picks = [];
          lists.forEach(function (l) { (l.products || []).forEach(function (p) {
            if (seen[p.id] || inCart[p.id]) return; seen[p.id] = 1;
            var v = bestVariant(p); if (v) picks.push({ p: p, v: v });
          }); });
          picks = picks.slice(0, limit);
          if (!picks.length) { box.hidden = true; return; }
          var row = box.querySelector('[data-pcr-row]');
          row.innerHTML = picks.map(function (x) {
            var img = x.p.featured_image ? '<img src="' + sized(x.p.featured_image, 260) + '" alt="" loading="lazy" width="120" height="120">' : '&nbsp;';
            return '<li><div class="pcr-card"><a class="pcr-img" href="' + esc(x.p.url) + '">' + img + '</a><div class="pcr-info">' +
              '<a class="pcr-name" href="' + esc(x.p.url) + '">' + esc(x.p.title) + '</a>' +
              '<span class="pcr-price">' + money(x.v.price) + '</span>' +
              '<button type="button" class="pcr-add" data-pcr-add="' + x.v.id + '">+ Add</button></div></div></li>';
          }).join('');
          row.scrollLeft = 0; box.hidden = false; navUpdate(box);
        });
      }).catch(function () {}).then(function () { recBusy = false; });
    }
    document.addEventListener('click', function (e) {
      var prev = e.target.closest && e.target.closest('[data-pcr-prev],[data-pcr-next]');
      if (prev) {
        var row = prev.closest('[data-pcr]').querySelector('[data-pcr-row]');
        row.scrollBy({ left: (prev.hasAttribute('data-pcr-next') ? 1 : -1) * (148 * 2), behavior: 'smooth' });
        return;
      }
      var add = e.target.closest && e.target.closest('[data-pcr-add]'); if (!add) return;
      e.preventDefault(); add.disabled = true; add.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(add.getAttribute('data-pcr-add'), 10), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { add.classList.add('is-done'); add.textContent = 'Added ✓'; return refreshDrawer(); })
        .then(function () { setTimeout(function () { loadRecs(true); }, 600); })
        .catch(function () { add.disabled = false; add.textContent = '+ Add'; });
    });
    document.addEventListener('scroll', function (e) {
      var row = e.target; if (row && row.matches && row.matches('[data-pcr-row]')) navUpdate(row.closest('[data-pcr]'));
    }, true);
    if (window.customElements) customElements.whenDefined('cart-drawer').then(function () {
      var CD = customElements.get('cart-drawer'); if (!CD || CD.prototype.__pcr) return;
      var origOpen = CD.prototype.open;
      CD.prototype.open = function () { var r = origOpen.apply(this, arguments); setTimeout(function () { loadRecs(false); }, 50); return r; };
      CD.prototype.__pcr = true;
    });
    document.addEventListener('afterUpdateQuantity', function () { setTimeout(function () { loadRecs(false); }, 300); });
    document.addEventListener('afterCartChanged', function () { setTimeout(function () { loadRecs(false); }, 300); });

    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f.matches || !f.matches('[data-pcc-form]')) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var box = f.closest('[data-pcc]'), input = f.querySelector('input'), btn = f.querySelector('button');
      var code = (input.value || '').trim();
      if (!code) { setMsg('Enter a Discount Code.', false); input.focus(); return; }
      var list = codesOf(box); if (list.map(function (c) { return c.toUpperCase(); }).indexOf(code.toUpperCase()) < 0) list.push(code);
      btn.disabled = true; setMsg('');
      applyCodes(list, code).catch(function () { setMsg('Something Went Wrong. Please Try Again.', false); }).then(function () { btn.disabled = false; });
    }, true);

    document.addEventListener('click', function (e) {
      var x = e.target.closest && e.target.closest('[data-pcc-remove]'); if (!x) return;
      e.preventDefault();
      var box = x.closest('[data-pcc]'), code = x.getAttribute('data-pcc-remove');
      var list = codesOf(box).filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
      x.disabled = true;
      applyCodes(list, code, true).catch(function () { x.disabled = false; });
    });
  })();
})();
